import React, { PropsWithChildren } from 'react';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { MaxWidthAndSpacingContainer, OverflowContainer } from './styles';

type GridContainerProps = {
  as?: keyof JSX.IntrinsicElements;
  role?: string;
} & ComponentProps;

const GridContainer: React.FC<PropsWithChildren<GridContainerProps>> = ({
  as,
  children,
  role,
  ...props
}) => (
  <OverflowContainer as={as}>
    <MaxWidthAndSpacingContainer role={role} {...componentProps(props)}>
      {children}
    </MaxWidthAndSpacingContainer>
  </OverflowContainer>
);

export default GridContainer;
